import type { LevelDef } from './types';

const L = (
  id: number,
  name: string,
  subtitle: string,
  paddleWidth: number,
  ballSpeed: number,
  rows: string[],
  extra: Partial<LevelDef> = {},
): LevelDef => ({ id, name, subtitle, paddleWidth, ballSpeed, rows, ...extra });

export const LEVELS: LevelDef[] = [
  L(1, 'Tutorial', 'Find the rhythm. Wide paddle, slow ball.', 188, 4.15, [
    '..............',
    '..............',
    '...nnnnnnnn...',
    '...nnnnnnnn...',
  ]),

  L(2, 'Getting Started', 'More rows. Watch for gold bonus bricks.', 172, 4.45, [
    '.nnnnnnnnnnnn.',
    'nnnnnnbnnnnnnn',
    '.nnnbnnnnnbnn.',
    'nnnnnnnnnnnnn.',
  ]),

  L(3, 'Variety', 'A chevron of strong bricks. Two hits each.', 158, 4.8, [
    '......ss......',
    '.....snns.....',
    '....snnnns....',
    '...snnbnnns...',
    '....snnnns....',
    '.....snns.....',
  ]),

  L(4, 'Challenge', 'Steel pillars. Thread the corridors.', 148, 5.2, [
    'i.nnnnnnnnnn.i',
    'i.nssnnnnssn.i',
    'i.nnnnbbnnnn.i',
    'i....i..i....i',
    'i.nnnneennnn.i',
    'i.ssnnnnnnss.i',
  ]),

  L(5, 'Mid-Game', 'Moving neon rows. Learn the swing.', 140, 5.5, [
    'iiii......iiii',
    's.nnnnnnnnnn.s',
    '..hhhhhhhhhh..',
    '..............',
    '..hhhhhhhhhh..',
    's.nnnbnnbnnn.s',
    'iiii......iiii',
  ]),

  L(6, 'Advanced', 'A steel maze. Tough cores need three hits.', 128, 5.9, [
    'i.ss.ii.ss.ii.',
    'i....ii....ii.',
    'ttnn.ii.nn.tt.',
    'i....ii....ii.',
    'i.ss.ii.ss.ii.',
    'i.tt.ee.tt.i..',
    'i....bb....i..',
  ]),

  L(
    7,
    'Expert',
    'Twin moving walls. You start with an extra ball.',
    118,
    6.3,
    [
      'iiii......iiii',
      '..hhhhhhhhhh..',
      'nnss......ssnn',
      '..hhhhhhhhhh..',
      '....ttbbtt....',
      'nnss......ssnn',
      'i....ee....i..',
    ],
    { startExtraBalls: 1, dropRateMul: 0.7 },
  ),

  L(
    8,
    'Master',
    'Dense cores and a spinning bar.',
    108,
    6.7,
    [
      '.tttttttttttt.',
      'ttssttssttsttt',
      '.tt.nnee.ttt..',
      'i............i',
      '.ssssbbsssss.',
      'tttt......tttt',
    ],
    {
      rotators: [{ x: 480, y: 268, length: 150, thickness: 14, speed: 1.15 }],
    },
  ),

  L(
    9,
    'Final Challenge',
    'A castle of steel, fire, and movers.',
    100,
    7.1,
    [
      'iiiiiiiiiiiiii',
      'i.ssttbbttss.i',
      'i.s........s.i',
      'hh.tttttttt.hh',
      'i.s..iiii..s.i',
      'i.ee......ee.i',
      'vv..........vv',
      '..nnssssssnn..',
    ],
    {
      startExtraBalls: 1,
      rotators: [{ x: 480, y: 310, length: 120, thickness: 12, speed: -1.05 }],
    },
  ),

  L(
    10,
    'Finale',
    'Every trick. Clear lanes. Finish it.',
    92,
    7.4,
    [
      'i.nsebtnsebti.',
      '.hh........hh.',
      'i.sstt..ttss.i',
      '....iiiiii....',
      'vv.nneeeenn.vv',
      'i.bb.tttt.bb.i',
      '.ssnn....nnss.',
      'i....bb....i..',
    ],
    {
      startExtraBalls: 2,
      dropRateMul: 0.55,
      rotators: [
        { x: 250, y: 300, length: 110, thickness: 12, speed: 1.25, phase: 0.4 },
        { x: 710, y: 300, length: 110, thickness: 12, speed: -1.25, phase: 1.1 },
      ],
    },
  ),
];

export function getLevel(id: number): LevelDef {
  const found = LEVELS.find((l) => l.id === id);
  if (!found) throw new Error(`unknown level ${id}`);
  return found;
}
